import { ReactNode } from 'react';
import { ChakraFlex, Text } from '@equip.health/ui';

type Props = {
  label: string;
  value: ReactNode;
};

export const TreatmentOverviewCardAttributeRow = ({ label, value }: Props) => {
  return (
    <ChakraFlex
      alignItems="center"
      aria-label={label}
      direction="row"
      gap="10px"
      marginTop="16px"
      role="row"
    >
      <ChakraFlex role="cell">
        <Text color="neutral.secondary" variant="caption" width="120px">
          {label}
        </Text>
      </ChakraFlex>
      <ChakraFlex role="cell">{value}</ChakraFlex>
    </ChakraFlex>
  );
};
